export default {"src":"/_next/static/media/gray-north-arrow.4486d27f.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};